<template>
  <div>
    <template v-if="!divisions.length">
      <button v-if="!loading" type="button" @click="getDivisions()" class="btn btn-default btn-sm">Показать не активные
        дивизионы
      </button>
      <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    </template>
    <template v-else>
      <div class="flex flex_gap_10 flex-wrap">
        <template v-for="d in divisions">
          <DivisionBtn :division="d"/>
        </template>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import DivisionBtn from "@/views/reports/components/DivisionBtn.vue";

export default {
  components: {DivisionBtn},
  props: ['load'],
  data() {
    return {
      loading: false,
      divisions: [],
    }
  },
  created() {
    if (this.load) {
      this.getDivisions();
    }
  },
  methods: {
    selectDivision(id) {
      console.log(id);
    },
    async getDivisions() {
      this.loading = true;
      const {data} = await api.index('/new/divisions/inactive');
      if (data.success) {
        this.divisions = _.orderBy(data.records, 'title').map((d) => {
          return {...d, selected: false};
        });
      } else {
        toastr["warning"](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>
